import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { Button, ButtonGroup, Input } from '@material-ui/core';
import { Button, ButtonGroup, Input, FormLabel,
     Box, Container, Typography, TextField } from '@mui/material';
import { loginAsync, selectApiStatus, selectIsLoggedIn, selectStatusText } from './LoginSlice';

const LoginForm = ({...props }) => {
    const dispatch = useDispatch();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    //const [submitted, setSubmitted] = useState(false);

    const apiStatus = useSelector(selectApiStatus);
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const statusText = useSelector(selectStatusText);

    const usernameEl = useRef(null)
    const passwordEl = useRef(null)

    const handleSubmit = () => {
        if (!isLoggedIn)
            dispatch(loginAsync({username:username,password:password}));
    }

    const handleClear = () => {
        setUsername('')
        setPassword('')
        usernameEl.current.focus();
    }

    //const dispatch = useDispatch();

    useEffect(() => {
        //setSubmitted(false);
    }, []);

    return (
        <Container component="main" maxWidth="xs">
            <Box sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Typography>Sign in</Typography>
                <Box component="form" onSubmit={handleSubmit}>
                {/*
                <Input type="text" name="username" inputRef={usernameEl}
                    value={username} onChange={e => setUsername(e.target.value)} />
                <Input type="password" name="password" inputRef={passwordEl}
                    value={password} onChange={e => setPassword(e.target.value)} />
                <ButtonGroup color="primary" aria-label="outlined primary button group">
                    <Button onClick={handleSubmit} disabled={apiStatus!=='idle'}>Login</Button >
                    <Button onClick={handleClear} disabled={apiStatus!=='idle'}>Clear</Button >
                </ButtonGroup>
                */}
                    <TextField margin="normal" required fullWidth id="username" label="Login Name" name="username" autoFocus  inputRef={usernameEl}
                        value={username} onChange={e => setUsername(e.target.value)}/>
                    <TextField margin="normal" required fullWidth id="password" label="Password" name="password" type="password" autoComplete="current-password" inputRef={passwordEl}
                        value={password} onChange={e => setPassword(e.target.value)}/>
                    <Button onClick={handleSubmit} fullWidth variant="contained" sx={{mt:3,mb:1}} disabled={apiStatus!=='idle'}>Login</Button>
                    <Button onClick={handleClear} fullWidth variant="contained" sx={{mt:1,mb:3}} disabled={apiStatus!=='idle'}>Clear</Button>
                    <Typography>{statusText}</Typography>
                </Box>
            </Box>
        </Container>
    );
};

export default LoginForm;